import axios from "axios"
import * as Sentry from "@sentry/nextjs"

const KNOWN_FORMS = new Set(["contact", "download", "estimate"])

export function headquartersContact(settings = {}) {
  const email = text(settings?.email)
  const phone = text(settings?.phone)
  if (email || phone) return { email, phone }

  const contacts = Array.isArray(settings?.footer?.contact)
    ? settings.footer.contact
    : []
  const chosen =
    contacts.find((entry) =>
      (entry?.offices || []).some((office) => /denmark/i.test(text(office?.title)))
    ) || contacts.find((entry) => text(entry?.email) || text(entry?.phone))

  return {
    email: text(chosen?.email),
    phone: text(chosen?.phone),
  }
}

export function classifyLeadFailure(error, status) {
  if (typeof status === "number" && status > 0) return "http"
  const code = error?.code
  if (code === "ECONNABORTED" || code === "ETIMEDOUT") return "timeout"
  return "network"
}

export async function postLead(url, body, options = {}) {
  try {
    const response = await axios.post(url, body, {
      headers: options.headers,
      timeout: options.timeout ?? 60000,
      validateStatus: () => true,
    })

    if (response.status >= 200 && response.status < 300) {
      return { ok: true, status: response.status, data: response.data }
    }

    const error = new Error(`Lead form failed (${response.status})`)
    reportClientFailure(error, url, response.status, "http")
    return { ok: false, status: response.status, kind: "http" }
  } catch (error) {
    const kind = classifyLeadFailure(error, 0)
    reportClientFailure(error, url, 0, kind)
    return { ok: false, status: 0, kind }
  }
}

function text(value) {
  return typeof value === "string" ? value.trim() : ""
}

function formFromLeadUrl(url) {
  const path = String(url || "").split("?")[0]
  if (path.endsWith("/api/contact-form")) return "contact"
  if (path.endsWith("/api/download-files")) return "download"
  if (
    path.endsWith("/api/estimation-email") ||
    path.endsWith("/api/estimation-pdf")
  ) {
    return "estimate"
  }
  return "unknown"
}

function reportClientFailure(error, url, status, kind) {
  const form = formFromLeadUrl(url)
  const safeForm = KNOWN_FORMS.has(form) ? form : "unknown"
  console.error(`[lead-form:${safeForm}] failed`, error)
  try {
    Sentry.captureException(error, {
      tags: { area: "lead_form", form: safeForm },
      extra: { status, kind },
    })
  } catch (sentryError) {
    console.error("[lead-form] client Sentry report failed", sentryError)
  }
}
